import { Helmet } from 'react-helmet';
import React, { useState} from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import axios from 'axios';
import { db } from './firebase';
import { collection, addDoc, query, where, getDocs, deleteDoc, doc } from 'firebase/firestore';
import AdminPanel from './AdminPanel';
import SubmissionPage from './SubmissionPage';

function MainApp() {
  const [bandName, setBandName] = useState('');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [userId] = useState(() => 'user_' + Math.random().toString(36).substr(2, 9));
const [votes, setVotes] = useState({ correct: 0, incorrect: 0 });
const [userVote, setUserVote] = useState(null);
const [reportSubmitted, setReportSubmitted] = useState(false);


  const KNOWN_HUMAN_ARTISTS = [
    'the beatles', 'beatles', 'taylor swift', 'drake', 'beyonce', 'beyoncé',
    'billie eilish', 'ed sheeran', 'ariana grande', 'kanye west', 'eminem',
    'rihanna', 'adele', 'bruno mars', 'coldplay', 'radiohead', 'nirvana',
    'pink floyd', 'led zeppelin', 'queen', 'david bowie', 'michael jackson',
    'madonna', 'prince', 'bob dylan', 'the rolling stones', 'u2', 'metallica',
    'ac/dc', 'guns n roses', 'red hot chili peppers', 'foo fighters', 'green day',
    'linkin park', 'imagine dragons', 'twenty one pilots', 'panic! at the disco',
    'fall out boy', 'paramore', 'blink-182', 'sum 41', 'the strokes', 'arctic monkeys',
    'kendrick lamar', 'j. cole', 'travis scott', 'post malone', 'the weeknd',
    'dua lipa', 'olivia rodrigo', 'bad bunny', 'bts', 'blackpink', 'yoasobi',
    'twice', 'seventeen', 'stray kids', 'txt', 'newjeans', 'ive', 'aespa',
    'doja cat', 'megan thee stallion', 'cardi b', 'sza', 'frank ocean',
    'sabrina carpenter', 'chappell roan', 'gracie abrams', 'tate mcrae', 'charli xcx'
  ];

  const KNOWN_AI_ARTISTS = [
    'the velvet sundown', 'velvet rebellion', 'false saints', 'pavement hymns',
    'broken avenue', 'obsidian swing', 'sunday night low', 'striking blue',
    'cold leftovers', 'ruby darkrose', 'nightshade anthem', 'the devil inside',
    'nick hustles', 'ghost//signal', 'underworld vibes', 'xania monet',
    'solomon ray', 'hope kills reality', 'exiles of eden', 'phantom verse',
    'shadows awake', 'lethal culture', 'invictus', 'deus metallicus',
    'neon pilgrims', 'static avenue', 'mia hayes', 'crimson overpass',
    'echoes at dusk', 'midnight monarchs', 'satellite bloom', 'plastic horizon',
    'bleeding verse', 'serinx', 'angel of anarchy', 'berserk fall',
    'deadluve', 'deathly hours', 'aventhis', 'j bumi', 'broken fate protocol',
    'iron dominion', 'void sermon', 'grave signal', 'ashes of syntax',
    'binary oblivion', 'code blackened', 'chrome burial', 'synthetic desecration',
    'hellform.exe', 'machine martyr', 'sienna rose', 'luna gray', 'nova quinn',
    'echo valentine', 'scarlett vega', 'mila nova', 'neon ivy', 'ava solace',
    'iris bloom', 'pixel heart', 'crystal lane', 'aria flux', 'violet skye',
    'starlight avenue', 'olivia chrome', 'solar kiss', 'fn meka', 'ghostwriter977',
    'lil byte', 'young algorithm', 'mc neural', 'dripnet', 'codeine ai',
    'trapgpt', 'digital don', 'flow.exe', 'neural flex', '808 phantom',
    'cyber rhymer', 'botboy millions', 'autotune oracle', 'synthetic hustla',
    'endel', 'yona.ai', 'ai dj project', 'neurobass', 'deep neural beats',
    'algorithmic groove unit', 'pulse pattern', 'synapse drift', 'midnight compute',
    'echo field', 'binary sunset', 'liquid circuit', 'autonomous wave',
    'chrome atmos', 'frequency ghost', 'breaking rust', 'highway outlaws',
    'waterfront wranglers', 'saltwater saddles', 'dusty trails union',
    'neon prairie', 'backroad protocol', 'rust belt revival', 'digital campfire',
    'lonesome loop', 'bootheel system', 'dub neural', 'king algorithm',
    'roots protocol', 'digital zion', 'echoes of babylon', 'lion.exe',
    'synthetic skank', 'ai marley project', 'dub circuitry', 'lofi logic',
    'jazznet collective', 'midnight café ai', 'blue note neural',
    'chillhop generator', 'study mode ensemble', 'coffee shop algorithm',
    'analog rain', 'static vinyl club', 'late night syntax', 'aiva',
    'amper music', 'euterpe ai', 'symphony neural', 'orchestra zero',
    'cinematic code', 'composerbot', 'scoremind', 'ambient engine',
    'filmcue ai', 'protostar ai', 'virtual harmony', 'neon idol unit',
    'pixel voice project', 'cyber diva x', 'vocalnet', 'austin ridge',
    'jamie springer', 'nick walker jr', 'ethan shore', 'caleb frost',
    'logan page', 'mason hale', 'tyler cross', 'noah rivers',
    'jackson bloom', 'oliver stonefield', 'wyatt lane', 'elliot ray',
    'cole mercer', 'lucas gray', "felix ruber", "dan ruse", "butterbro", "wittraider", "candace love",
  "tim cauty", "artic pulse", "techno sound group", "timmy drummond",
  "bandyquantguy", "ai-den", "shyke", "artificial expression",
  "ai composed songs", "sensori rume", "enerks", "the mike duncan project",
  "酒乐大咖", "timothy strange", "dtgr", "ai müzik", "upsidown",
  "gutter virgins", "chinchilla q.", "seventh sunset", "simon delalande",
  "ganthosmedia", "stratosaio", "backtimer", "the beatler", "tartek",
  "jimmuh puh", "jason maine projects", "digital flair",
  "mapping your soul astrology", "raffaele tremante", "daniel e. gindin",
  "daniel yosef stilman", "yolkhead", "the gary colorado experience",
  "torchier", "gardene music", "musaic", "tsg", "sup3rmass1ve",
  "dj nightshade", "circuitsoul", "kaidan", "sensei samurai", "jayne sugg",
  "the digital harmonics", "stikkabutta", "feline music", "dodoma cartier",
  "mrbazeman", "hell bros ai", "jodie's dad", "sula & suno", "david ai",
  "j'lord wimsely", "mode27", "guttao", "the dreamist", "anand.se",
  "the dolphin post", "ai music band", "milind chakraborty", "fallen doom",
  "vinyl solutions", "empi", "ludger van dusen", "cryptronik", "lara cains",
  "giovannie", "message from the future", "michael alø", "ai massive",
  "mike wright", "the_mad_end", "billamux", "skygge", "milla sofia",
  "die ki-putten", "space teddy", "blutbad-c", "the pirouettes", "nit",
  "nanashi_zero", "hidden layers", "roy hoggard", "automatic transition",
  "bl8antband", "synthetica 420", "ekesonman", "djschulle", "rarecello9893",
  "the velvet sundown", "church of the ignorati", "kardashiansauce",
  "der laufende meter", "collectif artificiel", "nkn beats", "kiesza",
  "phxfire", "quantumwaves", "eternal fluidity", "jay i. rich",
  "anonymous j256", "martin snelling", "the black bicycles", "crisederire",
  "redfactor", "nicholas elias", "joop rezemai", "c duncan", "lofi grogu",
  "varianz", "am 01:00", "heartland", "vespada", "vibe's quest", "makiaveli",
  "genius level theorem", "a wildheart's tale", "tyree d.", "idigitall",
  "tw rus", "chuch", "taryn southern", "l a hillier", "lm isaacson",
  "the illiac computer", "willi manilli", "xaras vii", "haihappen ki",
  "gener8", "the ace of cloves", "eudaimonia", "deaf vada", "cypher x",
  "the tape deck prophets", "stylize music", "lightjourner", "jambi da genie",
  "toni and the ai collective", "simfonique", "moonwxxker", "dariyah",
  "giada", "the sal neomoons experience", "rbelly", "the squeeze", "rplayin",
  "midnite foxx", "starlock", "julskinka", "the musical stoic", "jay billings",
  "fraktol", "derx", "dj-pope", "munciplay", "unibee", "perho",
  "cyberpulse machina", "tess tickles you", "for the bromance",
  "chumboryson dj", "los crias records", "mxvagang", "thistleblade",
  "suckin' jizzy", "docê˜ertroð˜", "celticraic",
  "citovitz and the fireflies of february", "bert mick", "dmc", "siyah",
  "berry's label", "aurorium vibes", "ken beimer ai", "janae", "aiiiia",
  "violin edm", "run4itmarty", "garnetflame", "flaherty brotherhood",
  "holloway", "snakedragon", "fontela", "leão flamejante",
  "manifested dreams", "dan bressers", "supranova xo", "asya rüzgarı",
  "jan & the cyber monks", "tunzuu", "alice curly", "aibry", "ailia hikaru",
  "syrolune", "alyto", "1 biscuit records", "chaff monkey", "mikirah muse",
  "tyrone williams", "xania monet", "millien", "sprung bits", "amulius",
  "ai retro radio hits", "jj.moreno", "strange crush", "breaking rust",
  "blue idoru", "silas cane", "jovan blaze", "raging depths", "sandy s",
  "ascendence", "skadder", "phil bryan", "vox vermis", "embr",
  "paradox force", "the gothique", "idealhopes", "aura rozi", "inner abyss",
  "urban grizzly", "dj ate o'clock", "nahla noir", "nox", "kris menace",
  "black hills", "oliver", "nl rush", "cyborg soul", "newman groove",
  "analog future", "broken altar", "the devil inside", "frostbite orckings",
  "chaos x2", "shsslayer", "the silent static", "elliath rexed", "madok958",
  "juliet whesky", "trotskix", "slutzilla", "mockingbird soundwave",
  "eclipse byte", "nifumesound", "killcam", "rob taylor", "imaginary youth",
  "alice.exe", "sumpol", "smokehammer", "country roads revival",
  "avelyn walker", "glass howl", "ash johansen", "simbaxp", "skinzz",
  "arystina", "from june to december", "the gripe", "lladnaros", "liri dais",
  "landslide", "bots with guitars", "an errant bullet", "mats olausson",
  "christaris", "dozart", "piestrikesback", "sinkopate", "eidolon scar",
  "xkto", "hollowheart", "404firmware", "metal dog", "xander::stylez",
  "brimtown", "joy exposure", "pale in comparison", "ephi entropy",
  "saint fantasy", "downrange98", "v1nom", "symulate 7", "sleeping with wolves",
  "prasanth madhurapantula", "pero_neko", "inekaramugi", "nova cat",
  "kappa/jpn", "the redemptions", "kaiyana", "mofata", "fab65", "kazamineko",
  "neo pop", "susumu.", "soulwave lounge", "karmonster", "corey vibe",
  "kumagoro", "nene&j", "お祭りヒーローズ", "stonestreet", "eternity", "mave",
  "superkind", "neon flower", "higashi zoma", "rew", "across italy",
  "takezou7", "the power alchemist", "moon soul", "funkorama",
  "ghost chords music", "agentic orange", "shifty brent", "aventhis",
  "ruby darkrose", "melania maye", "olivia b. rose", "kairo mansa",
  "mary of gold", "r3alson", "fall to pieces", "noiryte", "moonshine outlaws",
  "hollow ember", "the feal", "matthew's silent chapter", "dark country boy",
  "the black mammoth", "a wildheart's tale niniel", "doc raven",
  "frontier heart", "colter rayne", "cain walker", "broker altar",
  "true sacrifice", "kanegi", "lyra vesperi", "benn jordan",
  "crimson collapse", "king willonius", "true roots blues", "good vibes tribe",
  "the soulful gentlemen", "beyond disdain", "skars", "machine six",
  "max city", "god is love", "unbound music", "street gospel syndicate",
  "morgan luna", "jesus country music group", "616", "a shrine to failure",
  "black angel", "blood.twin", "corpus delicti", "dance society",
  "daniel ash", "dead born babies", "die krupps", "horreur cosmique",
  "inkubus sukkubus", "lacrimosa", "leather strip", "midnight darkwave",
  "midnight masq", "moonvampire", "the penthouse plants", "rosetta stone",
  "twin tribes", "horror disco", "sequence voque", "wyatt creed",
  "midnight soul session", "寿司娘", "tuki hikaru", "n3", "kairo kan",
  "myespressivo", "pugs world", "sorna", "marc hann", "amari", "ailllla",
  "british venture", "subhumanfusion", "pair o'dee's", "kon",
  "bean wagon ai", "bean wagon", "carl sanders", "scene stock", "kiwa",
  "gero bob", "326 yasube-", "nemesistube", "art", "lebanon hanover",
  "sentiencegeneration", "mark gottlieb", "the kettlemen",
  "rew's metal eternal", "zoleta", "apes on ape", "spalexma", "a7m",
  "kingcon2k11", "katherine jayne", "tata taktumi", "user 771815816",
  "everything everything", "pale sun disorder", "crimson daydream",
  "aja ireland", "yasunao tone", "dadabots", "safetensors", "oscob",
  "glorb", "the fooming shoggoths", "blorg", "hypergammaglobulinemia",
  "bread experiments", "obscurest vinyl", "girly girl productions",
  "rose mulet", "king cobra", "finally unalived", "lunatick",
  "blueberryclub", "risen in ash", "teeth of eden",
  "ghosts of american intellects", "kionx", "riley77", "lumocore",
  "charis studio", "esslll", "miguel pascal", "the last spell", "synaptic",
  "b twizzy", "total metal destruction", "peron", "dumpster grooves",
  "merciless cult", "the old tavern", "lmbsa", "within the stars",
  "sermon of flies", "nymik rose", "5 days left", "nukehole", "everendora",
  "miyavi amore", "may bee", "ganso smith", "quinzena", "cut davis",
  "vurtist", "manifestica_studio", "kenobix", "amarie",
  "everhits-moritabari", "lg0r", "r3alson리슨", "jw broken veteran",
  "lipocalypse", "runenhain", "if rappers made country", "home alone.",
  "sybilanta", "artificial individual", "mermaidonmars", "riottheory",
  "shadowthorn", "araé", "seth abstract", "deuceai", "rosie k",
  "mela mirage", "after midnight", "abscond", "dannyho", "just the jinx",
  "zancrowstudio", "relatone", "jerry's sound room", "hellena banner",
  "s. quill", "kintsugi crusade", "twisted f8", "logofox", "nicola nicoletti",
  "antonin herbeck", "angelina mormando", "mokepouch", "photoserge",
  "shadoweyemusic", "rizzers", "velvet funk", "wyatt blueridge", "eon veil",
  "sonya grace", "novaine", "until nothing", "tripstone heathen", "angelbaby",
  "ethan horahn", "jay carney", "dropghost", "preaching real", "antikaa",
  "broken record kids", "veilr", "nekonoma", "icy mattrix", "ily ghoul",
  "yui", "moebius fm", "silas grime", "solitary haze", "kalebae music",
  "smartyr", "j . prodigy", "yiikes", "wizflow tunes", "soaring metal lords",
  "samuel cabana", "mythicrealm", "miyunique", "hroth", "horizon tunes",
  "feral cry", "7even sins", "l'aurah", "johnny red keys callahan",
  "western plains radio", "elle.", "sa'lunara", "after midnight deep",
  "eufonia", "ida nik", "schlagermelle", "my boy arlo", "sunshine girl",
  "nordic versecraft", "vargnokturn", "poisonpop candy", "nordskãld",
  "bardtholomew", "starwynd", "amazy music", "bitblood", "hroldar",
  "dj kneupp", "viviana belle rey", "miles laroque", "pause maybe?",
  "intimate vibes", "rikki", "black mustang defense", "lazygold",
  "nona cyrelle", "emberosia", "art roseman", "letters from ghosts",
  "holy groove", "dozy duzzn", "sellar", "daimon noir", "narroway",
  "narita metalaw", "celestial melodies", "melodia simples", "most high",
  "hushveil", "violete ephemerty", "digital delusions", "djsource",
  "bardcore medieval style", "synn", "yesterday once again", "salen records",
  "voxnaris", "nick hustles", "aetherealdream", "slvmlord", "beach days",
  "smoke-oh", "alphonic", "witchsnook", "mythictune",
  "ashley klein maddision", "chrome vultures", "heaven//error", "retrosync",
  "shadow reign", "nox resonantia", "szepty starych drzew",
  "pradawne dźwięki", "cogs of the night", "kealux", "alice's ghosts",
  "dystøne", "sasha komovich", "hangover carousel", "we are still here",
  "rocking rebel", "lxne", "nox averill", "lock & key vibes", "nyxara",
  "the love algorithm", "desyoh", "darklux", "éther dark motivation",
  "kelvin west", "ol man yarn", "themidnightblackout", "velora",
  "wake up falling", "wild one", "velvet rebellion", "false saints",
  "pavement hymns", "broken avenue", "obsidian swing", "sunday night low",
  "striking blue", "cold leftovers", "nightshade anthem", "ghost//signal",
  "underworld vibes", "solomon ray", "hope kills reality", "exiles of eden",
  "phantom verse", "shadows awake", "lethal culture", "invictus",
  "deus metallicus", "neon pilgrims", "static avenue", "mia hayes",
  "crimson overpass", "echoes at dusk", "midnight monarchs",
  "satellite bloom", "plastic horizon", "bleeding verse", "serinx",
  "angel of anarchy", "berserk fall", "deadluve", "deathly hours",
  "broken fate protocol", "iron dominion", "void sermon", "grave signal",
  "ashes of syntax", "binary oblivion", "code blackened", "chrome burial",
  "synthetic desecration", "hellform.exe", "machine martyr", "sienna rose",
  "luna gray", "nova quinn", "echo valentine", "scarlett vega", "mila nova",
  "neon ivy", "ava solace", "iris bloom", "pixel heart", "crystal lane",
  "aria flux", "violet skye", "starlight avenue", "olivia chrome",
  "solar kiss", "fn meka", "ghostwriter977", "lil byte", "young algorithm",
  "mc neural", "dripnet", "codeineai", "trapgpt", "digital don", "flow.exe",
  "neural flex", "808 phantom", "cyber rhymer", "botboy millions",
  "autotune oracle", "synthetic hustla", "endel", "yona.ai", "ai dj project",
  "neurobass", "deep neural beats", "algorithmic groove unit",
  "pulse pattern", "synapse drift", "midnight compute", "echo field",
  "binary sunset", "liquid circuit", "autonomous wave", "chrome atmos",
  "frequency ghost", "highway outlaws", "waterfront wranglers",
  "saltwater saddles", "dusty trails union", "neon prairie",
  "backroad protocol", "rust belt revival", "digital campfire",
  "lonesome loop", "bootheel system", "dub neural", "king algorithm",
  "roots protocol", "digital zion", "echoes of babylon", "lion.exe",
  "synthetic skank", "ai marley project", "dub circuitry", "lofi logic",
  "jazznet collective", "midnight café ai", "blue note neural",
  "chillhop generator", "study mode ensemble", "coffee shop algorithm",
  "analog rain", "static vinyl club", "late night syntax", "aiva",
  "amper music", "euterpe ai", "symphony neural", "orchestra zero",
  "cinematic code", "composerbot", "scoremind", "ambient engine",
  "filmcue ai", "protostar ai", "virtual harmony", "neon idol unit",
  "pixel voice project", "cyber diva x", "vocalnet", "austin ridge",
  "jamie springer", "nick walker jr", "ethan shore", "caleb frost",
  "logan page", "mason hale", "tyler cross", "noah rivers", "jackson bloom",
  "oliver stonefield", "wyatt lane", "elliot ray", "cole mercer",
  "lucas gray", "syncsphere", "biwaneco", "maniwa party", "shua3588",
  "jazzy.kei2", "aven starling", "naniwa bounce", "candy pink", "pikaru",
  "m. miraa", "shyy", "jasmine allstar", "liberty road rebels",
  "james stuart baker", "canyon blackwood", "axel storme", "josh fawaz",
  "talon creed", "nikoela", "krishool"
  ];

  const MAJOR_LABELS = [
    'universal', 'sony', 'warner', 'columbia', 'atlantic', 'capitol',
    'interscope', 'rca', 'republic', 'def jam', 'epic', 'virgin',
    'parlophone', 'emi', 'elektra', 'geffen', 'island', 'polydor',
    'mercury', 'decca', 'asylum', 'motown', 'arista', 'jive',
    'j records', 'cash money', 'young money', 'aftermath', 'shady',
    'good music', 'ovo', 'dreamville', 'top dawg', 'quality control',
    '300 entertainment', 'big hit', 'hybe', 'sm entertainment',
    'yg entertainment', 'jyp entertainment', 'avex', 'king records'
  ];

  const isKnownHuman = (name) => {
    const nameLower = name.toLowerCase().trim();
    return KNOWN_HUMAN_ARTISTS.some(artist => 
      nameLower === artist || nameLower.includes(artist) || artist.includes(nameLower)
    );
  };

  const isKnownAI = (name) => {
    const nameLower = name.toLowerCase().trim();
    return KNOWN_AI_ARTISTS.some(artist => 
      nameLower === artist || nameLower.includes(artist) || artist.includes(nameLower)
    );
  };

  const hasMajorLabel = (labels) => {
    if (!labels || labels.length === 0) return false;
    const labelNames = labels.map(l => (l.name || '').toLowerCase());
    return MAJOR_LABELS.some(major => labelNames.some(label => label.includes(major)));
  };

  const searchLastFM = async (artistName) => {
    try {
      const response = await axios.get(
        `https://ws.audioscrobbler.com/2.0/?method=artist.getinfo&artist=${encodeURIComponent(artistName)}&format=json&api_key=demo`
      );
      if (response.data.artist) {
        const stats = response.data.artist.stats || {};
        const bio = response.data.artist.bio || {};
        let yearsActive = null;
        const bioText = bio.summary || bio.content || '';
        const yearsMatch = bioText.match(/(\d{4})[-–—]\s*(?:(\d{4})|present)/i);
        if (yearsMatch) {
          const startYear = parseInt(yearsMatch[1]);
          const endYear = yearsMatch[2] ? parseInt(yearsMatch[2]) : new Date().getFullYear();
          yearsActive = endYear - startYear;
        }
        return {
          listeners: parseInt(stats.listeners) || 0,
          playcount: parseInt(stats.playcount) || 0,
          image: response.data.artist.image?.[3]?.['#text'] || null,
          url: response.data.artist.url || null,
          yearsActive: yearsActive
        };
      }
      return null;
    } catch (err) {
      return null;
    }
  };

  const checkWikipedia = async (artistName) => {
    try {
      const response = await axios.get(
        `https://en.wikipedia.org/w/api.php?action=query&titles=${encodeURIComponent(artistName)}&format=json&origin=*&prop=extracts|info&inprop=url&exintro=1`
      );
      const pages = response.data.query.pages;
      const pageId = Object.keys(pages)[0];
      if (pageId === '-1') return { exists: false };
      const page = pages[pageId];
      const extract = page.extract || '';
      let yearsActive = null;
      const yearsMatch = extract.match(/active.*?(\d{4})[-–—]\s*(?:(\d{4})|present)/i);
      if (yearsMatch) {
        const startYear = parseInt(yearsMatch[1]);
        const endYear = yearsMatch[2] ? parseInt(yearsMatch[2]) : new Date().getFullYear();
        yearsActive = endYear - startYear;
      }
      return {
        exists: true,
        url: page.fullurl || `https://en.wikipedia.org/wiki/${encodeURIComponent(artistName)}`,
        yearsActive: yearsActive
      };
    } catch (err) {
      return { exists: false };
    }
  };

  const searchMusicBrainz = async (artistName) => {
    try {
      await new Promise(resolve => setTimeout(resolve, 1000));
      const response = await axios.get(
        `https://musicbrainz.org/ws/2/artist/?query=artist:${encodeURIComponent(artistName)}&fmt=json&limit=1`
      );
      if (!response.data.artists || response.data.artists.length === 0) return null;
      return response.data.artists[0];
    } catch (err) {
      return null;
    }
  };
 const searchDeezer = async (artistName) => {
  try {
    // Use CORS proxy to bypass browser restrictions
    const response = await axios.get(
     `/.netlify/functions/deezer?artist=${encodeURIComponent(artistName)}`
    );
    
    if (!response.data.data || response.data.data.length === 0) return null;
    
    // Normalize: remove periods, extra spaces, make lowercase
    const normalize = (str) => str.toLowerCase().replace(/\./g, '').replace(/\s+/g, '');
    const searchNormalized = normalize(artistName);
    
    const match = response.data.data.find(artist => {
      const artistNormalized = normalize(artist.name);
      
      // Exact match after normalization
      if (artistNormalized === searchNormalized) return true;
      
      // Close match
      const lengthDiff = Math.abs(artistNormalized.length - searchNormalized.length);
      if (lengthDiff <= 3 && (artistNormalized.includes(searchNormalized) || searchNormalized.includes(artistNormalized))) {
        return true;
      }
      
      return false;
    });
    
    if (match) {
      // Fetch artist's albums to get accurate count
      let albumCount = 0;
      try {
        const albumResponse = await axios.get(
          `/.netlify/functions/deezer?artist=${encodeURIComponent(artistName)}`
        );
        albumCount = albumResponse.data.total || albumResponse.data.data?.length || 0;
      } catch (err) {
        console.error('Error fetching Deezer albums:', err);
      }
      
      return {
        id: match.id,
        name: match.name,
        picture: match.picture_big,
        fans: match.nb_fan,
        link: match.link,
        albumCount: albumCount
      };
    }
    
    return null;
  } catch (err) {
    console.error('Deezer error:', err);
    return null;
  }
};
const getArtistDetails = async (artistId) => {
  try {
    await new Promise(resolve => setTimeout(resolve, 1000));
    const response = await axios.get(
      `https://musicbrainz.org/ws/2/artist/${artistId}?inc=releases+url-rels&fmt=json`
    );
    return response.data;
  } catch (err) {
    return null;
  }
};

const checkSocialMedia = (artistDetails) => {
  if (!artistDetails || !artistDetails.relations) {
    return { hasSocial: false, platforms: [], links: {} };
  }
  const socialPlatforms = [];
  const links = {};
  const relations = artistDetails.relations || [];
  relations.forEach(rel => {
    const url = rel.url?.resource || '';
    if (url.includes('instagram.com')) {
      socialPlatforms.push('Instagram');
      links.instagram = url;
    }
    if (url.includes('twitter.com') || url.includes('x.com')) {
      socialPlatforms.push('Twitter/X');
      links.twitter = url;
    }
    if (url.includes('facebook.com')) {
      socialPlatforms.push('Facebook');
      links.facebook = url;
    }
    if (url.includes('tiktok.com')) {
      socialPlatforms.push('TikTok');
      links.tiktok = url;
    }
    if (url.includes('youtube.com')) {
      socialPlatforms.push('YouTube');
      links.youtube = url;
    }
    if (url.includes('spotify.com')) {
      links.spotify = url;
    }
    if (url.includes('bandcamp.com')) {
      links.bandcamp = url;
    }
    if (url.includes('soundcloud.com')) {
      links.soundcloud = url;
    }
    if (url.includes('apple.com/') || url.includes('music.apple')) {
      links.appleMusic = url;
    }
  });
  return {
    hasSocial: socialPlatforms.length > 0,
    platforms: [...new Set(socialPlatforms)],
    links: links
  };
};

const getRecordLabels = async (artistId) => {
  try {
    await new Promise(resolve => setTimeout(resolve, 1000));
    const response = await axios.get(
      `https://musicbrainz.org/ws/2/release?artist=${artistId}&fmt=json&limit=50`
    );
    const releases = response.data.releases || [];
    const labels = [];
    releases.forEach(release => {
      if (release['label-info']) {
        release['label-info'].forEach(labelInfo => {
          if (labelInfo.label && labelInfo.label.name) {
            labels.push(labelInfo.label);
          }
        });
      }
    });
    const uniqueLabels = labels.filter((label, index, self) =>
      index === self.findIndex(l => l.id === label.id)
    );
    return uniqueLabels;
  } catch (err) {
    return [];
  }
};

const analyzeReleases = async (artistId) => {
  try {
    await new Promise(resolve => setTimeout(resolve, 1000));
    const response = await axios.get(
      `https://musicbrainz.org/ws/2/release?artist=${artistId}&fmt=json&limit=100`
    );
    const releases = response.data.releases || [];
    const releasesWithDates = releases.filter(r => r.date && r.date.length >= 4);
    if (releasesWithDates.length === 0) {
      return { releasesPerMonth: 0, totalReleases: releases.length, careerYears: 0 };
    }
    const sorted = releasesWithDates.sort((a, b) => new Date(b.date) - new Date(a.date));
    const newest = new Date(sorted[0].date);
    const oldest = new Date(sorted[sorted.length - 1].date);
    const monthsDiff = (newest - oldest) / (1000 * 60 * 60 * 24 * 30);
    const releasesPerMonth = monthsDiff > 0 ? releasesWithDates.length / monthsDiff : 0;
    const sixMonthsAgo = new Date();
    sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
    const recentReleases = releasesWithDates.filter(r => new Date(r.date) > sixMonthsAgo);
    return {
      releasesPerMonth,
      totalReleases: releases.length,
      recentReleases: recentReleases.length,
      careerYears: monthsDiff / 12
    };
  } catch (err) {
    return { releasesPerMonth: 0, totalReleases: 0, recentReleases: 0, careerYears: 0 };
  }
};

const loadVotes = async (artistName) => {
  try {
    const votesRef = collection(db, 'votes');
    const q = query(votesRef, where('artistName', '==', artistName.toLowerCase()));
    const snapshot = await getDocs(q);
    let correct = 0, incorrect = 0, userVoted = null;
    snapshot.forEach(d => {
      const data = d.data();
      if (data.voteType === 'correct') correct++;
      if (data.voteType === 'incorrect') incorrect++;
      if (data.userId === userId) userVoted = data.voteType;
    });
    setVotes({ correct, incorrect });
    setUserVote(userVoted);
  } catch (err) {
    console.error('Error loading votes:', err);
  }
};

const submitVote = async (voteType) => {
  try {
    const votesRef = collection(db, 'votes');
    const q = query(votesRef, where('artistName', '==', result.artistName.toLowerCase()), where('userId', '==', userId));
    const existing = await getDocs(q);
    for (const d of existing.docs) await deleteDoc(doc(db, 'votes', d.id));
    await addDoc(votesRef, {
      artistName: result.artistName.toLowerCase(),
      voteType: voteType,
      userId: userId,
      timestamp: new Date().toISOString()
    });
    setUserVote(voteType);
    loadVotes(result.artistName);
  } catch (err) {
    alert('Error submitting vote. Please try again.');
  }
};

const reportAsAI = async () => {
  try {
    await addDoc(collection(db, 'reports'), {
      artistName: result.artistName,
      reportType: 'ai',
      timestamp: new Date().toISOString(),
      userId: userId,
      evidence: { percentage: result.percentage, flags: result.flags }
    });
    setReportSubmitted(true);
    setTimeout(() => setReportSubmitted(false), 3000);
  } catch (err) {
    alert('Error submitting report.');
  }
};

const reportAsWrong = async () => {
  try {
    await addDoc(collection(db, 'reports'), {
      artistName: result.artistName,
      reportType: 'correction',
      currentVerdict: result.verdict,
      timestamp: new Date().toISOString(),
      userId: userId
    });
    setReportSubmitted(true);
    setTimeout(() => setReportSubmitted(false), 3000);
  } catch (err) {
    alert('Error submitting report.');
  }
};
  const detectAI = async () => {
    if (!bandName.trim()) return;
    setLoading(true);
    setError(null);
    setResult(null);

    try {
      const artistName = bandName.trim();

      if (isKnownHuman(artistName)) {
        setResult({
          artistName: artistName,
          percentage: 0,
          verdict: 'VERIFIED HUMAN',
          flags: [{ severity: 'low', text: '✓ Artist is in our verified human artists database' }],
          isWhitelisted: true
        });
        setLoading(false);
        return;
      }

      if (isKnownAI(artistName)) {
        setResult({
          artistName: artistName,
          percentage: 100,
          verdict: 'CONFIRMED AI',
          flags: [{ severity: 'critical', text: '⚠ Artist is in our confirmed AI-generated music database' }],
          isBlacklisted: true
        });
        setLoading(false);
        return;
      }

  // Try Deezer first (more accurate)
let deezerData = await searchDeezer(artistName);
let mbArtist = null;

// If Deezer fails, fallback to MusicBrainz
if (!deezerData) {
  mbArtist = await searchMusicBrainz(artistName);
}

const [wikiData, lfmData] = await Promise.all([
  checkWikipedia(artistName),
  searchLastFM(artistName)
]);

      if (!deezerData && !mbArtist && !lfmData) {
        setError(`No artist found with name "${artistName}". Try checking the spelling.`);
        setLoading(false);
        return;
      }

      let artistDetails = null;
      let labels = [];
      let socialMedia = { hasSocial: false, platforms: [], links: {} };
      let releaseAnalysis = { releasesPerMonth: 0, totalReleases: 0, recentReleases: 0, careerYears: 0 };

      if (mbArtist) {
        [artistDetails, labels, releaseAnalysis] = await Promise.all([
          getArtistDetails(mbArtist.id),
          getRecordLabels(mbArtist.id),
          analyzeReleases(mbArtist.id)
        ]);
        if (artistDetails) {
          socialMedia = checkSocialMedia(artistDetails);
        }
      }

      let yearsActive = null;
      if (wikiData.yearsActive) {
        yearsActive = wikiData.yearsActive;
      } else if (lfmData?.yearsActive) {
        yearsActive = lfmData.yearsActive;
      } else if (releaseAnalysis.careerYears > 0) {
        yearsActive = releaseAnalysis.careerYears;
      }

      const finalYears = yearsActive || releaseAnalysis.careerYears;

      let score = 0;
      const flags = [];

      const signedToMajor = hasMajorLabel(labels);
      if (signedToMajor) {
        score -= 35;
        const labelName = labels.find(l => 
          MAJOR_LABELS.some(major => l.name.toLowerCase().includes(major))
        )?.name;
        flags.push({
          severity: 'low',
          text: `✓ Signed to major label: ${labelName} (very strong human indicator)`
        });
      } else if (labels.length > 0) {
        score -= 15;
        flags.push({ severity: 'low', text: `✓ Has record label: ${labels[0].name}` });
      }

      if (socialMedia.hasSocial) {
        score -= 25;
        flags.push({
          severity: 'low',
          text: `✓ Active on: ${socialMedia.platforms.join(', ')} (human verified)`
        });
      } else {
        score += 15;
        flags.push({ severity: 'medium', text: '⚠ No social media links found in database' });
      }

      if (wikiData.exists) {
        score -= 30;
        flags.push({ severity: 'low', text: '✓ Has Wikipedia page (established artist)' });
      }

      if (lfmData) {
        if (lfmData.listeners > 100000) {
          score -= 25;
          flags.push({
            severity: 'low',
            text: `✓ ${lfmData.listeners.toLocaleString()} Last.fm listeners (very popular)`
          });
        } else if (lfmData.listeners > 10000) {
          score -= 15;
          flags.push({
            severity: 'low',
            text: `✓ ${lfmData.listeners.toLocaleString()} Last.fm listeners`
          });
        } else if (lfmData.listeners < 100 && releaseAnalysis.totalReleases > 5) {
          score += 15;
          flags.push({
            severity: 'high',
            text: `⚠ Many releases but only ${lfmData.listeners} listeners`
          });
        }
      }

      if (finalYears > 5) {
        score -= 20;
        flags.push({
          severity: 'low',
          text: `✓ Active for ${finalYears.toFixed(1)} years`
        });
      } else if (finalYears > 2) {
        score -= 10;
        flags.push({
          severity: 'low',
          text: `✓ Active for ${finalYears.toFixed(1)} years`
        });
      }

      if (!wikiData.exists && !socialMedia.hasSocial) {
  if (releaseAnalysis.releasesPerMonth > 4) {
    score += 35;
    flags.push({
      severity: 'critical',
      text: `⚠ Very high release rate: ${releaseAnalysis.releasesPerMonth.toFixed(1)} releases/month`
    });
  } else if (releaseAnalysis.releasesPerMonth > 2) {
    score += 20;
    flags.push({
      severity: 'high',
      text: `High release rate: ${releaseAnalysis.releasesPerMonth.toFixed(1)} releases/month`
    });
  }
}

      if (finalYears < 0.5 && releaseAnalysis.totalReleases > 10) {
        score += 25;
        flags.push({
          severity: 'high',
          text: `⚠ Brand new artist with ${releaseAnalysis.totalReleases} releases`
        });
      }

      const aiKeywords = ['ai', 'bot', 'digital', 'synthetic', 'generated', 'virtual', 'cyber', 'neural'];
      if (aiKeywords.some(kw => artistName.toLowerCase().includes(kw))) {
        score += 20;
        flags.push({ severity: 'high', text: '⚠ Artist name contains AI-related keywords' });
      }

      if (labels.length === 0 && !socialMedia.hasSocial && releaseAnalysis.totalReleases > 3) {
        score += 20;
        flags.push({
          severity: 'high',
          text: '⚠ No record label, no social media, but has releases'
        });
      }

      score = Math.min(100, Math.max(0, score));

    let verdict;
if (score >= 70) verdict = 'DEFINITELY AI';
else if (score >= 50) verdict = 'PROBABLY AI';
else if (score >= 30) verdict = 'POSSIBLY AI';
else if (score > 0) verdict = 'PROBABLY HUMAN';
else verdict = 'VERIFIED HUMAN';

      setResult({
        artistName: deezerData?.name || mbArtist?.name || artistName,
        percentage: score,
        verdict,
        flags,
        totalReleases: deezerData?.albumCount || releaseAnalysis.totalReleases,
        listeners: lfmData?.listeners || 0,
        hasWikipedia: wikiData.exists,
        wikipediaUrl: wikiData.url,
        hasSocialMedia: socialMedia.hasSocial,
        socialPlatforms: socialMedia.platforms,
        socialLinks: socialMedia.links,
        lastFmUrl: lfmData?.url,
        recordLabel: labels.length > 0 ? labels[0].name : 'Independent',
        hasMajorLabel: signedToMajor,
        careerYears: finalYears ? finalYears.toFixed(1) : 'Unknown',
        releasesPerMonth: releaseAnalysis.releasesPerMonth.toFixed(2),
        artistImage: deezerData?.picture || lfmData?.image,
        musicbrainzUrl: mbArtist ? `https://musicbrainz.org/artist/${mbArtist.id}` : null
      });

    } catch (err) {
      console.error('Detection error:', err);
      setError(err.message || 'An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const getVerdictColor = (percentage) => {
    if (percentage >= 70) return '#dc2626';
    if (percentage >= 50) return '#ea580c';
    if (percentage >= 30) return '#ca8a04';
    return '#16a34a';
  };

  const getSeverityColor = (severity) => {
    const colors = {
      critical: '#dc2626',
      high: '#ea580c',
      medium: '#ca8a04',
      low: '#16a34a'
    };
    return colors[severity] || '#6b7280';
  };

  return (
    <div style={styles.container}>
      <Helmet>
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": "Is This Band AI?",
            "description": "Free AI music detection tool to check if a band or artist uses AI-generated music",
            "url": "https://isthisbandai.org",
            "applicationCategory": "MusicApplication",
            "operatingSystem": "Any",
            "offers": {
              "@type": "Offer",
              "price": "0",
              "priceCurrency": "USD"
            }
          }
        `}
      </script>
    </Helmet>
      <div style={styles.content}>
        <h1 style={styles.title}>Is This Band AI?</h1>
        <p style={styles.subtitle}>
          Check if a band or artist is AI from our music database.
        </p>

        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
  <a href="/submit" style={{ color: '#1a1a1a', textDecoration: 'none', fontSize: '15px', fontWeight: '600', padding: '10px 20px', backgroundColor: 'white', borderRadius: '6px', display: 'inline-block', border: '1px solid #e0e0e0' }}>
    Submit an Artist for Review
  </a>
</div>


        <div style={styles.searchBox}>
          <input
            type="text"
            value={bandName}
            onChange={(e) => setBandName(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && detectAI()}
            placeholder="Enter band or artist name..."
            style={styles.input}
          />
          <button 
            onClick={detectAI}
            disabled={loading || !bandName.trim()}
            style={{
              ...styles.button,
              opacity: (loading || !bandName.trim()) ? 0.5 : 1,
              cursor: (loading || !bandName.trim()) ? 'not-allowed' : 'pointer'
            }}
          >
            {loading ? 'Analyzing...' : 'Check'}
          </button>
        </div>

        {error && (
          <div style={styles.error}>
            <p>❌ {error}</p>
            <p style={{ marginTop: '15px', fontSize: '14px' }}>
      Can't find this artist? <a href="/submit" style={{ color: '#991b1b', textDecoration: 'underline', fontWeight: 'bold' }}>Submit artist/band to database →</a>
    </p>
          </div>
        )}

        {loading && (
          <div style={styles.loading}>
            <div style={styles.spinner}></div>
            <p>Comprehensive analysis in progress...</p>
            <p style={{fontSize: '14px', color: '#6b7280', marginTop: '10px'}}>
              Checking social media • Record labels • Wikipedia • Release patterns
            </p>
          </div>
        )}

        {result && !loading && (
          <div style={styles.result}>
            {result.artistImage && (
              <img 
                src={result.artistImage} 
                alt={result.artistName}
                style={styles.artistImage}
              />
            )}

            <h2 style={styles.artistName}>{result.artistName}</h2>
            
            <h2 style={{
              ...styles.verdict,
              color: result.isWhitelisted ? '#16a34a' : result.isBlacklisted ? '#dc2626' : getVerdictColor(result.percentage)
            }}>
              {result.verdict}
            </h2>
            
            {!result.isWhitelisted && !result.isBlacklisted && (
              <>
                <div style={styles.confidence}>
                  {result.percentage}%
                </div>
                <p style={styles.confidenceLabel}>AI Likelihood Score</p>
              </>
            )}
            {/* Voting Section */}
{!result.isWhitelisted && !result.isBlacklisted && (
  <div style={{ marginTop: '20px', padding: '20px', backgroundColor: '#f9fafb', borderRadius: '12px' }}>
    <p style={{ fontSize: '14px', fontWeight: '600', color: '#374151', marginBottom: '10px' }}>Is this result accurate?</p>
    <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
      <button onClick={() => submitVote('correct')} style={{ padding: '10px 20px', borderRadius: '8px', border: 'none', fontSize: '14px', fontWeight: '600', cursor: 'pointer', backgroundColor: userVote === 'correct' ? '#16a34a' : '#e5e7eb', color: userVote === 'correct' ? 'white' : '#374151' }}>
        👍 Yes ({votes.correct})
      </button>
      <button onClick={() => submitVote('incorrect')} style={{ padding: '10px 20px', borderRadius: '8px', border: 'none', fontSize: '14px', fontWeight: '600', cursor: 'pointer', backgroundColor: userVote === 'incorrect' ? '#dc2626' : '#e5e7eb', color: userVote === 'incorrect' ? 'white' : '#374151' }}>
        👎 No ({votes.incorrect})
      </button>
    </div>
  </div>
)}

{/* Report Buttons */}
<div style={{ marginTop: '20px', display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>
  {!result.isBlacklisted && result.percentage < 70 && (
    <button onClick={reportAsAI} style={{ padding: '10px 20px', backgroundColor: '#f59e0b', color: 'white', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: 'pointer' }}>
      🚨 Report as AI
    </button>
  )}
  {!result.isWhitelisted && (
    <button onClick={reportAsWrong} style={{ padding: '10px 20px', backgroundColor: '#f59e0b', color: 'white', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: 'pointer' }}>
      ⚠️ This result is wrong
    </button>
  )}
  {reportSubmitted && <p style={{ color: '#16a34a', fontSize: '14px', fontWeight: '600', marginTop: '10px', width: '100%', textAlign: 'center' }}>✓ Report submitted! Thank you.</p>}
</div>
{/* Submit Artist Link */}
<div style={{ marginTop: '20px', textAlign: 'center', padding: '16px', backgroundColor: '#f9fafb', borderRadius: '12px' }}>
  <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '8px' }}>
    Know an AI artist that's not in our database?
  </p>
  <a href="/submit" style={{ color: '#667eea', textDecoration: 'none', fontWeight: '600', fontSize: '15px' }}>
    Submit an Artist for Review →
  </a>
</div>

            {!result.isBlacklisted && (
              <div style={styles.stats}>
                <div style={styles.stat}>
                  <div style={styles.statValue}>{result.totalReleases || 'N/A'}</div>
                  <div style={styles.statLabel}>Total Releases</div>
                </div>
                <div style={styles.stat}>
                  <div style={styles.statValue}>{result.careerYears || 'N/A'}</div>
                  <div style={styles.statLabel}>Years Active</div>
                </div>
                <div style={styles.stat}>
                  <div style={styles.statValue}>{result.releasesPerMonth || 'N/A'}</div>
                  <div style={styles.statLabel}>Releases/Month (Estimate)</div>
                </div>
              </div>
            )}

            {result.hasSocialMedia && result.socialPlatforms && result.socialPlatforms.length > 0 && (
              <div style={styles.socialBadges}>
                {result.socialPlatforms.map(platform => (
                  <span key={platform} style={styles.badge}>{platform}</span>
                ))}
              </div>
            )}

            {result.recordLabel && result.recordLabel !== 'Independent' && !result.isBlacklisted && (
              <div style={styles.labelInfo}>
                <strong>Label:</strong> {result.recordLabel}
                {result.hasMajorLabel && <span style={styles.majorLabel}> (Major Label)</span>}
              </div>
            )}

            {!result.isBlacklisted && (result.hasWikipedia || result.hasSocialMedia || result.socialLinks) && (
              <div style={styles.verificationSection}>
                <h3 style={styles.verificationTitle}>🔗 Verification Links</h3>
                <div style={styles.linkGrid}>
                  {result.wikipediaUrl && (
                    <a href={result.wikipediaUrl} target="_blank" rel="noopener noreferrer" style={styles.verifyLink}>
                      📖 Wikipedia
                    </a>
                  )}
                  {result.lastFmUrl && (
                    <a href={result.lastFmUrl} target="_blank" rel="noopener noreferrer" style={styles.verifyLink}>
                      🎵 Last.fm
                    </a>
                  )}
                  {result.socialLinks?.spotify && (
                    <a href={result.socialLinks.spotify} target="_blank" rel="noopener noreferrer" style={styles.verifyLink}>
                      🎧 Spotify
                    </a>
                  )}
                  {result.socialLinks?.instagram && (
                    <a href={result.socialLinks.instagram} target="_blank" rel="noopener noreferrer" style={styles.verifyLink}>
                      📷 Instagram
                    </a>
                  )}
                  {result.socialLinks?.twitter && (
                    <a href={result.socialLinks.twitter} target="_blank" rel="noopener noreferrer" style={styles.verifyLink}>
                      🐦 Twitter/X
                    </a>
                  )}
                  {result.socialLinks?.youtube && (
                    <a href={result.socialLinks.youtube} target="_blank" rel="noopener noreferrer" style={styles.verifyLink}>
                      ▶️ YouTube
                    </a>
                  )}
                  {result.socialLinks?.facebook && (
                    <a href={result.socialLinks.facebook}target="_blank" rel="noopener noreferrer" style={styles.verifyLink}>
                      👥 Facebook
                    </a>
                  )}
                  {result.socialLinks?.tiktok && (
                    <a href={result.socialLinks.tiktok} target="_blank" rel="noopener noreferrer" style={styles.verifyLink}>
                      🎬 TikTok
                    </a>
                  )}
                  {result.socialLinks?.bandcamp && (
                    <a href={result.socialLinks.bandcamp} target="_blank" rel="noopener noreferrer" style={styles.verifyLink}>
                      🎸 Bandcamp
                    </a>
                  )}
                  {result.socialLinks?.soundcloud && (
                    <a href={result.socialLinks.soundcloud} target="_blank" rel="noopener noreferrer" style={styles.verifyLink}>
                      ☁️ SoundCloud
                    </a>
                  )}
                  {result.socialLinks?.appleMusic && (
                    <a href={result.socialLinks.appleMusic} target="_blank" rel="noopener noreferrer" style={styles.verifyLink}>
                      🍎 Apple Music
                    </a>
                  )}
                </div>
              </div>
            )}

            {result.flags && result.flags.length > 0 && (
              <div style={styles.flagsSection}>
                <h3 style={styles.flagsTitle}>Detection Signals:</h3>
                {result.flags.map((flag, idx) => (
                  <div 
                    key={idx} 
                    style={{
                      ...styles.flag,
                      borderLeft: `4px solid ${getSeverityColor(flag.severity)}`
                    }}
                  >
                    {flag.text}
                  </div>
                ))}
              </div>
            )}

            {result.musicbrainzUrl && (
              <a 
                href={result.musicbrainzUrl} 
                target="_blank" 
                rel="noopener noreferrer"
                style={styles.link}
              >
                View on MusicBrainz →
              </a>
            )}
          </div>
        )}

        <div style={styles.footer}>
          <p>Using artist metadata, online presence, and other release metrics from our comprehensive music database, this tool determines the likelihood of a band or artist being AI or human. </p>
          <p style={{fontSize: '12px', marginTop: '5px'}}>
            Please note that this tool is merely a likelihood indicator and may contain inaccuracies in search results.
          </p>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
     minHeight: '100vh',
  backgroundColor: '#f8f9fa',
  padding: '20px',
  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif',
  minWidth: '100vw',
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0
},
  content: {
    maxWidth: '800px',
    margin: '0 auto',
    paddingTop: '60px'
  },
  title: {
    fontSize: '56px',
    color: '#1a1a1a',
    textAlign: 'center',
    marginBottom: '8px',
    fontWeight: '700',
    letterSpacing: '-0.02em'
  },
  subtitle: {
    fontSize: '18px',
    color: '#666',
    textAlign: 'center',
    marginBottom: '40px',
    fontWeight: '400'
  },
  searchBox: {
    display: 'flex',
    gap: '12px',
    marginBottom: '40px',
    backgroundColor: 'white',
    padding: '8px',
    borderRadius: '8px',
    border: '1px solid #e0e0e0',
    boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
  },
  input: {
    flex: 1,
    padding: '14px 18px',
    fontSize: '16px',
    border: 'none',
    borderRadius: '6px',
    outline: 'none',
    backgroundColor: 'transparent'
  },
  button: {
    padding: '14px 32px',
    fontSize: '16px',
    backgroundColor: '#1a1a1a',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    fontWeight: '600',
    transition: 'background-color 0.2s',
    cursor: 'pointer'
  },
  loading: {
    backgroundColor: 'white',
    padding: '60px 40px',
    borderRadius: '12px',
    textAlign: 'center',
    border: '1px solid #e0e0e0'
  },
  spinner: {
    width: '40px',
    height: '40px',
    border: '3px solid #f0f0f0',
    borderTop: '3px solid #1a1a1a',
    borderRadius: '50%',
    margin: '0 auto 20px auto',
    animation: 'spin 0.8s linear infinite'
  },
  error: {
    backgroundColor: '#fff5f5',
    color: '#c53030',
    padding: '20px',
    borderRadius: '8px',
    marginBottom: '20px',
    textAlign: 'center',
    border: '1px solid #feb2b2'
  },
  result: {
    backgroundColor: 'white',
    padding: '48px',
    borderRadius: '12px',
    textAlign: 'center',
    border: '1px solid #e0e0e0',
    boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
  },
  artistImage: {
    width: '160px',
    height: '160px',
    borderRadius: '4px',
    marginBottom: '24px',
    objectFit: 'cover',
    border: '1px solid #e0e0e0'
  },
  artistName: {
    fontSize: '32px',
    fontWeight: '700',
    color: '#1a1a1a',
    marginBottom: '16px',
    letterSpacing: '-0.01em'
  },
  verdict: {
    fontSize: '28px',
    fontWeight: '700',
    marginBottom: '12px',
    letterSpacing: '-0.01em'
  },
  confidence: {
    fontSize: '72px',
    fontWeight: '700',
    color: '#1a1a1a',
    lineHeight: '1',
    marginTop: '8px'
  },
  confidenceLabel: {
    color: '#666',
    fontSize: '14px',
    marginBottom: '32px',
    fontWeight: '500',
    textTransform: 'uppercase',
    letterSpacing: '0.05em'
  },
  stats: {
    display: 'flex',
    justifyContent: 'space-around',
    marginBottom: '24px',
    paddingTop: '32px',
    borderTop: '1px solid #e0e0e0'
  },
  stat: {
    textAlign: 'center'
  },
  statValue: {
    fontSize: '28px',
    fontWeight: '700',
    color: '#1a1a1a'
  },
  statLabel: {
    fontSize: '12px',
    color: '#666',
    marginTop: '4px',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    fontWeight: '500'
  },
  socialBadges: {
    display: 'flex',
    gap: '8px',
    justifyContent: 'center',
    flexWrap: 'wrap',
    marginBottom: '24px'
  },
  badge: {
    padding: '6px 14px',
    backgroundColor: '#f0f0f0',
    color: '#1a1a1a',
    borderRadius: '4px',
    fontSize: '13px',
    fontWeight: '500',
    border: '1px solid #e0e0e0'
  },
  labelInfo: {
    padding: '14px',
    backgroundColor: '#f8f9fa',
    borderRadius: '6px',
    marginBottom: '24px',
    fontSize: '14px',
    border: '1px solid #e0e0e0'
  },
  majorLabel: {
    color: '#1a1a1a',
    fontWeight: '600'
  },
  verificationSection: {
    marginTop: '32px',
    paddingTop: '32px',
    borderTop: '1px solid #e0e0e0',
    textAlign: 'left'
  },
  verificationTitle: {
    fontSize: '16px',
    marginBottom: '16px',
    color: '#1a1a1a',
    textAlign: 'center',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '0.05em'
  },
  linkGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))',
    gap: '10px',
    marginBottom: '10px'
  },
  verifyLink: {
    display: 'block',
    padding: '10px 12px',
    backgroundColor: '#f8f9fa',
    color: '#1a1a1a',
    textDecoration: 'none',
    borderRadius: '6px',
    fontSize: '13px',
    fontWeight: '500',
    textAlign: 'center',
    border: '1px solid #e0e0e0',
    transition: 'background-color 0.2s'
  },
  flagsSection: {
    textAlign: 'left',
    marginTop: '32px',
    paddingTop: '32px',
    borderTop: '1px solid #e0e0e0'
  },
  flagsTitle: {
    fontSize: '16px',
    marginBottom: '16px',
    color: '#1a1a1a',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '0.05em'
  },
  flag: {
    padding: '12px 16px',
    backgroundColor: '#f8f9fa',
    marginBottom: '8px',
    borderRadius: '6px',
    fontSize: '14px',
    border: '1px solid #e0e0e0'
  },
  link: {
    display: 'inline-block',
    marginTop: '24px',
    padding: '12px 24px',
    backgroundColor: '#1a1a1a',
    color: 'white',
    textDecoration: 'none',
    borderRadius: '6px',
    fontWeight: '600',
    fontSize: '14px',
    transition: 'background-color 0.2s'
  },
  footer: {
    marginTop: '48px',
    textAlign: 'center',
    color: '#666',
    fontSize: '14px',
    lineHeight: '1.6'
  }
};
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainApp />} />
        <Route path="/submit" element={<SubmissionPage />} />
        <Route path="/admin" element={<AdminPanel />} />
      </Routes>
    </Router>
  );
}
export default App;